import { useCallback, MouseEventHandler, PointerEvent, PointerEventHandler } from 'react';

/** Returns a pointer event handler that calls a corresponding mouse event handler only for primary pointers. */
export function useAsPrimaryPointerEvent<T>(
    mouseEventHandler: MouseEventHandler<T>
): PointerEventHandler<T> {
    return useCallback(
        (e: PointerEvent<T>) => {
            if (e.isPrimary) {
                mouseEventHandler(e);
            }
        },
        [mouseEventHandler]
    );
}
